module.exports = __webpack_public_path__ + "img/pin(circle-x-large-004d40)-icon(awesome-home-medium)-@2x-2.43d1a624.png";